import { render } from "./Detail.vue?vue&type=template&id=56a8c617&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=ts"
export * from "./Detail.vue?vue&type=script&lang=ts"

import "./Detail.vue?vue&type=style&index=0&id=56a8c617&lang=scss&scoped=true"
import "./Detail.vue?vue&type=style&index=1&id=56a8c617&lang=css"
script.render = render
script.__scopeId = "data-v-56a8c617"

export default script